import { JSFSelect, JSFSelectUncontrolled } from '~/components/jsonschema/VndlyJsonSchemaFormBase/widgets/select'
import { asFormikField } from '~/common/formikUtils'
import { isClient } from '~/common/nextJsUtils'

const TimezoneSelect = ({ id, name, value, initialValue, onChange, isUncontrolled = false }) => {
  const JSFSelectComponent = isUncontrolled ? JSFSelectUncontrolled : JSFSelect
  const valueProps = isUncontrolled ? { initialValue } : { value }
  return (
    <JSFSelectComponent
      id={id}
      name={name}
      {...valueProps}
      options={{
        preloadFromApi: {
          url: '/api/v2/timezones/'
        }
      }}
      menuPortalTarget={isClient() && document.body}
      onChange={onChange}
    />
  )
}

const formikPropMapper = ({ field, form }) => ({
  onChange: val => form.setFieldValue(field.name, val)
})
export default asFormikField(TimezoneSelect, formikPropMapper)
